module.exports = __webpack_public_path__ + "static/unrivaled_leaders-d473e1b9230c87b8532b0aad5e219f21.jpg";